/**
 * Deposit Rates API service
 * Fetches HKD time deposit rate data from the backend.
 */
import api from './axios.config';

/* ── Types ── */

export interface LocalizedString {
  zh: string;
  en: string;
}

export interface HighlightItem {
  bank: string;
  rate: string;
  tenor: string;
  condition: string;
  featured: boolean;
}

export interface BankRateEntry {
  id: string;
  name: LocalizedString;
  rates: {
    '1m': string | null;
    '3m': string | null;
    '6m': string | null;
    '12m': string | null;
  };
  minDeposit: LocalizedString;
  notes: LocalizedString;
}

export interface DepositRatesData {
  lastUpdated: string;
  highlights: {
    zh: HighlightItem[];
    en: HighlightItem[];
  };
  traditionalBanks: BankRateEntry[];
  virtualBanks: BankRateEntry[];
}

/* ── API ── */

export const depositRatesApi = {
  /**
   * Get the latest HKD time deposit rates for all banks.
   */
  getRates: async (): Promise<DepositRatesData> => {
    const response = await api.get<DepositRatesData>('/api/v1/deposit-rates/');
    return response.data;
  },
};
